// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Menu":"bht_a bii_h","Menu__offsetParent":"bht_b bii_bj","Menu__trigger--shadowed":"bht_c"};